import script from "./VideoElement.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoElement.vue?vue&type=script&setup=true&lang=js"

import "./VideoElement.vue?vue&type=style&index=0&id=2ea26294&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea26294"]])

export default __exports__